import './Apllos.css'
import { useTranslation } from 'react-i18next'

const Apllos = () => {
  const { t } = useTranslation()

  return (
    <section className="main-container Apllos">
      <header className="main-container-top ApllosTop">
        <div className="text">
          <h2>
            <span>Απλος</span>(Apllos) - {t('apllos_page.title')}
          </h2>

          <p>{t('apllos_page.description')}</p>
        </div>

        <div className="ApllosInfo">
          <div className="ValueSection">
            <img
              src="/assets/Apllos/horizontal structure.png"
              alt={t('apllos_page.values.horizontalStructure.title')}
            />
            <h3>{t('apllos_page.values.horizontalStructure.title')}</h3>
            <p>{t('apllos_page.values.horizontalStructure.description')}</p>
          </div>

          <div className="ValueSection">
            <img
              src="/assets/Apllos/committed specialists.png"
              alt={t('apllos_page.values.committedSpecialists.title')}
            />
            <h3>{t('apllos_page.values.committedSpecialists.title')}</h3>
            <p>{t('apllos_page.values.committedSpecialists.description')}</p>
          </div>

          <div className="ValueSection">
            <img
              src="/assets/Apllos/innovative solutions.png"
              alt={t('apllos_page.values.innovativeSolutions.title')}
            />
            <h3>{t('apllos_page.values.innovativeSolutions.title')}</h3>
            <p>{t('apllos_page.values.innovativeSolutions.description')}</p>
          </div>
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h2>{t('apllos_page.essence.title')}</h2>

          <p>{t('apllos_page.essence.p1')}</p>

          <p>{t('apllos_page.essence.p2')}</p>

          <p>{t('apllos_page.essence.p3')}</p>

          <p>{t('apllos_page.essence.p4')}</p>

          <p>{t('apllos_page.essence.p5')}</p>
        </div>
      </div>
    </section>
  )
}

export default Apllos
